import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import {
  AbilitySubjectType,
  AttachmentType,
  IAttachment,
} from '@kinet-open-network/shared/data-access/model';

export class Attachment
  extends BaseModel<Attachment, 'Attachment'>
  implements IAttachment
{
  static override readonly modelName: AbilitySubjectType = 'Attachment';
  name!: string | null;
  mimeType?: string;
  data!: string | null;
  extra?: Record<string, any>;
  extType!: AttachmentType | null;
  extId!: string | null;

  get dataUrl(): string | null {
    if (!this.data) {
      return null;
    }

    const mimeType = this.mimeType || 'application/octet-stream';

    return `data:${mimeType};base64,${this.data}`;
  }
}
